import { useTranslation } from 'react-i18next';
import { categoryName, type Category } from '../model/types';

/**
 * Hook that returns a function for resolving a localised category name
 * using the current i18next locale.
 */
export function useCategoryName() {
  const { i18n } = useTranslation();
  return (cat: Pick<Category, 'name' | 'slug'> | undefined | null): string => {
    if (!cat) return '';
    return categoryName(cat, i18n.language || 'en');
  };
}
